import { render, staticRenderFns } from "./PlaidWrap.vue?vue&type=template&id=07560b32"
import script from "./PlaidWrap.vue?vue&type=script&lang=js"
export * from "./PlaidWrap.vue?vue&type=script&lang=js"
import style0 from "./PlaidWrap.vue?vue&type=style&index=0&id=07560b32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports